module.exports = __webpack_public_path__ + "img/start-but.d24d716f.png";